export const ROOT = '/asset_tracking';
export const MODULE = 'ASSET_TRACKING';
